module.exports = __webpack_public_path__ + "img/business.736e929a.webp";